module.exports = __webpack_public_path__ + "fundo.jpg?c463c2031d4e851e7be18a7619231e6c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fundo.jpg
// module id = 741
// module chunks = 0